export default __webpack_public_path__ + "static/media/CNo.39-3.61dbd4cc.jpg";